function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classnames from 'classnames';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import Notification from './components/notification';
import classes from './dropdown-input.scss';
export function DropdownInput({
  input,
  label,
  labelClassName,
  wrapperClassName,
  className,
  dataInput,
  input: {
    onChange,
    name,
    value
  } = {},
  meta: {
    touched,
    active,
    error
  } = {},
  defaultValue,
  values = [],
  disabled
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, label && /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.label, labelClassName)
  }, label), /*#__PURE__*/React.createElement(DropDownMenu, {
    className: classnames(classes.dropdown, className),
    value: value || defaultValue,
    onChange: (event, index, val) => onChange && onChange(val),
    disabled: disabled
  }, values.map((v, i) => /*#__PURE__*/React.createElement(MenuItem, {
    key: `${i}_${v.value}`,
    value: v.value,
    primaryText: v.label
  }))), /*#__PURE__*/React.createElement("input", _extends({
    value: value || defaultValue
  }, input, {
    type: "hidden",
    name: name,
    "data-input": dataInput
  })), touched && !active && /*#__PURE__*/React.createElement(Notification, {
    message: error
  }));
}